import { CustomSectionState } from 'api/custom-section/types';
import { FC, useState } from 'react';
import { PeoplePageSourceDerivedQuestionSectionComponentProps } from '../types';
import { PeoplePageSourceDerivedQuestionSectionPromptInput } from './prompt-input';
import { PeoplePageSourceDerivedQuestionSectionPromptPreview } from './prompt-preview';

export const PeoplePageSourceDerivedQuestionSectionPrompt: FC<
  PeoplePageSourceDerivedQuestionSectionComponentProps
> = (props) => {
  const [isEditing, setIsEditing] = useState(
    props.node.attrs.state === CustomSectionState.Open,
  );

  return (
    <div>
      {isEditing ? (
        <PeoplePageSourceDerivedQuestionSectionPromptInput
          {...props}
          onEditDone={() => {
            setIsEditing(false);
          }}
        />
      ) : (
        <PeoplePageSourceDerivedQuestionSectionPromptPreview
          {...props}
          onWrapperClick={() => {
            setIsEditing(true);
          }}
        />
      )}
    </div>
  );
};
